@switch (state()) {
  @case ('speakers') {
    <fa-icon
      role="img"
      [icon]="faVolumeSlash"
      [attr.aria-label]="'Speakers muted' | translate"></fa-icon>
  }
  @case ('mic') {
    <fa-icon
      role="img"
      [icon]="faMicrophoneSlash"
      [attr.aria-label]="'Microphone muted' | translate"></fa-icon>
  }
}
